/**
 * Returns a function that runs `loader` once and shares the same promise.
 *
 * @param {() => Promise<unknown>} loader
 * @returns {() => Promise<unknown>}
 */
export function createLazyLoader(loader) {
  /** @type {Promise<unknown> | null} */
  let promise = null;

  return () => {
    if (!promise) promise = loader();
    return promise;
  };
}
